import { createBrowserRouter } from "react-router-dom";
import { RequireAuth } from "./components/require-auth";
import { ErrorPage } from "./pages/error";
import { AuthLayout } from "./layouts/auth-layout";
import { RootLayout } from "./layouts/root-layout";
import { DashboardLayout } from "./layouts/dashboard-layout";
import { AdminCatalogPage } from "./pages/admin/catalog";
import { AdminCouponsPage } from "./pages/admin/coupons";
import { AdminDashboardPage } from "./pages/admin/dashboard";
import { AdminOrdersPage } from "./pages/admin/orders";
import { AdminProjectsPage } from "./pages/admin/projects";
import { AdminPurchasingPage } from "./pages/admin/purchasing";
import { AdminReportsPage } from "./pages/admin/reports";
import { AdminSettingsPage } from "./pages/admin/settings";
import { AdminSuppliersPage } from "./pages/admin/suppliers";
import { AdminUsersPage } from "./pages/admin/users";
import { CartPage } from "./pages/cart";
import { CheckoutPage } from "./pages/checkout";
import { HomePage } from "./pages/home";
import { InvoicePage } from "./pages/invoice";
import { LoginPage } from "./pages/login";
import { ProductPage } from "./pages/product";
import { ProjectPage } from "./pages/project";
import { ProjectsPage } from "./pages/projects";
import { SalesCatalogPage } from "./pages/sales/catalog";
import { SalesCouponsPage } from "./pages/sales/coupons";
import { SalesDashboardPage } from "./pages/sales/dashboard";
import { SalesCustomersPage } from "./pages/sales/customers";
import { SalesInvoicePage } from "./pages/sales/invoice";
import { SalesInvoicesPage } from "./pages/sales/invoices";
import { SalesOrdersPage } from "./pages/sales/orders";
import { SalesPaymentsPage } from "./pages/sales/payments";
import { SalesProfilePage } from "./pages/sales/profile";
import { SalesReceiptPage } from "./pages/sales/receipt";
import { SearchPage } from "./pages/search";
import { ShopPage } from "./pages/shop";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "shop", element: <ShopPage /> },
      { path: "shop/categories/:categoryId/:categoryName", element: <ShopPage /> },
      { path: "shop/search", element: <SearchPage /> },
      { path: "shop/cart", element: <CartPage /> },
      { path: "shop/checkout", element: <CheckoutPage /> },
      { path: "shop/invoice", element: <InvoicePage /> },
      { path: "projects", element: <ProjectsPage /> },
      { path: "projects/:slug/:projectId", element: <ProjectPage /> },
      { path: "projects/:slug", element: <ProjectPage /> },
      { path: "shop/product/:name/:productId", element: <ProductPage /> },
      { path: "shop/product/:name", element: <ProductPage /> }
    ]
  },
  {
    path: "/auth",
    element: <AuthLayout />,
    errorElement: <ErrorPage />,
    children: [{ path: "login", element: <LoginPage /> }]
  },
  {
    path: "/sales",
    element: (
      <RequireAuth allowedRoles={["SALES", "ADMIN"]}>
        <DashboardLayout mode="sales" title="Sales Console" />
      </RequireAuth>
    ),
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <SalesDashboardPage /> },
      { path: "orders", element: <SalesOrdersPage /> },
      { path: "payments", element: <SalesPaymentsPage /> },
      { path: "catalog", element: <SalesCatalogPage /> },
      { path: "customers", element: <SalesCustomersPage /> },
      { path: "coupons", element: <SalesCouponsPage /> },
      { path: "invoices", element: <SalesInvoicesPage /> },
      { path: "profile", element: <SalesProfilePage /> }
    ]
  },
  {
    path: "/sales/receipt",
    element: (
      <RequireAuth allowedRoles={["SALES", "ADMIN"]}>
        <SalesReceiptPage />
      </RequireAuth>
    ),
    errorElement: <ErrorPage />
  },
  {
    path: "/sales/invoice",
    element: (
      <RequireAuth allowedRoles={["SALES", "ADMIN"]}>
        <SalesInvoicePage />
      </RequireAuth>
    ),
    errorElement: <ErrorPage />
  },
  {
    path: "/admin",
    element: (
      <RequireAuth allowedRoles={["ADMIN"]}>
        <DashboardLayout mode="admin" title="Admin Console" />
      </RequireAuth>
    ),
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <AdminDashboardPage /> },
      { path: "catalog", element: <AdminCatalogPage /> },
      { path: "orders", element: <AdminOrdersPage /> },
      { path: "suppliers", element: <AdminSuppliersPage /> },
      { path: "purchasing", element: <AdminPurchasingPage /> },
      { path: "users", element: <AdminUsersPage /> },
      { path: "coupons", element: <AdminCouponsPage /> },
      { path: "projects", element: <AdminProjectsPage /> },
      { path: "reports", element: <AdminReportsPage /> },
      { path: "settings", element: <AdminSettingsPage /> }
    ]
  }
]);
